import UserNotification from "util/UserNotification";
import { fetchBlobFile, fetchFile } from "logic/rest/FetchProvider";
export const createLinkAndDownload = (href, fileName) => {
  const a = document.createElement("a");
  a.href = href;
  a.download = fileName;
  if (document.body) {
    document.body.appendChild(a);
  }
  a.click();
  a.remove();
};
export const downloadBLOB = (contents, metadata) => {
  const blob = new Blob([contents], { type: metadata.contentType });
  const href = window.URL.createObjectURL(blob);
  createLinkAndDownload(href, metadata.fileName);
};
const errorHandler = (errorThrown) => {
  UserNotification.error(`Downloading failed with status: ${errorThrown}`, "Unable to download");
};
export const fetchTextFile = async (method, url, body, mimeType, fileName) => fetchFile(method, url, body, mimeType).then((result) => downloadBLOB(result, { fileName, contentType: mimeType })).catch(errorHandler);
export const fetchBinaryFile = async (method, url, body, mimeType, fileName) => fetchBlobFile(method, url, body, mimeType).then((result) => downloadBLOB(result, { fileName, contentType: mimeType })).catch(errorHandler);
